export default __webpack_public_path__ + "static/media/coinbase.6a8e6e7d.svg";